/**
 * A trip's dispatch page has one tab, the overview, at `/dispatch/trips/:id/overview`. The other names stay as routes only so the old links
 * keep working: they redirect to the same tab on the trip's own page (`features/trips`).
 */
export const DISPATCH_TRIP_TABS = ['overview', 'record', 'cash', 'timeline', 'accessorials'] as const;
export type DispatchTripTab = (typeof DISPATCH_TRIP_TABS)[number];

export const dispatchPaths = {
  assignTrip: (tripId: string) => `/dispatch/trips/${tripId}/assign`,
  /** The bare path redirects to the overview tab. */
  dispatchTrip: (tripId: string) => `/dispatch/trips/${tripId}`,
  home: '/dispatch',
} as const;
